import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner-border",
  role: "status"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
const _hoisted_3 = [
  _hoisted_2
]

import { ref } from 'vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    onClick: { type: Function },
    waitText: {},
    text: {}
  },
  setup(__props: any) {

const isWaiting = ref(false);

const props = __props;

const doClick = () => {
    console.log("button clicked");
    isWaiting.value = true;
    const result = props.onClick();

    // Check if result is a Promise
    if (result && typeof result.then === 'function' && typeof result.catch === 'function') {
        result.then(() => {
            isWaiting.value = false;
        }).catch(() => {
            isWaiting.value = false;
        });
    } else {
        isWaiting.value = false;
    }
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "btn btn-primary rounded",
      onClick: doClick
    }, _toDisplayString(props.text), 1),
    (isWaiting.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true)
  ], 64))
}
}

})